var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftAngleBracket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80005 6.00005L6.70005 9.90005C6.88338 10.0834 6.97505 10.3167 6.97505 10.6C6.97505 10.8834 6.88338 11.1167 6.70005 11.3C6.51672 11.4834 6.28338 11.575 6.00005 11.575C5.71672 11.575 5.48338 11.4834 5.30005 11.3L0.700049 6.70005C0.600049 6.60005 0.529215 6.49172 0.487549 6.37505C0.445882 6.25838 0.425049 6.13338 0.425049 6.00005C0.425049 5.86672 0.445882 5.74172 0.487549 5.62505C0.529215 5.50838 0.600049 5.40005 0.700049 5.30005L5.30005 0.700049C5.48338 0.516715 5.71672 0.425049 6.00005 0.425049C6.28338 0.425049 6.51672 0.516715 6.70005 0.700049C6.88338 0.883382 6.97505 1.11672 6.97505 1.40005C6.97505 1.68338 6.88338 1.91672 6.70005 2.10005L2.80005 6.00005Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAngleBracket);
export default __webpack_public_path__ + "static/media/left-angle-bracket.cafa96afd1d6ecfcadc5b47633fad450.svg";
export { ForwardRef as ReactComponent };